import React from "react";

import styles from "./style.module.css";

import Select from "react-select";

import { Button } from "aible";

export default class MarketplaceSelect extends React.PureComponent {
  handleSelect(option) {
    const { selectMarketplace } = this.props;
    selectMarketplace(option.value);
  }
  render() {
    const { marketplaces, selectedMarketplace, createInternalMarketplace, isLoading } = this.props;
    const options = marketplaces.map((marketplace) => {
      return { label: marketplace.title, value: marketplace.id };
    });
    return (
      <div className={styles.marketplaceSelectWrapper}>
        {marketplaces && marketplaces.length > 1 ? (
          <Select
            placeholder={"Select Marketplace"}
            value={{ label: selectedMarketplace.title, value: selectedMarketplace.id }}
            options={options}
            onChange={(option) => this.handleSelect(option)}
            isSearchable={false}
          />
        ) : (
          ""
        )}
        {marketplaces && marketplaces.length < 2 ? (
          <Button type="secondary" onClick={createInternalMarketplace} disabled={isLoading}>
            Create Internal Marketplace
          </Button>
        ) : (
          ""
        )}
      </div>
    );
  }
}
